module.exports = __webpack_public_path__ + "img/review-5.e79bb198.png";